module.exports = __webpack_public_path__ + "static/img/video_airoad.ed051a88.png";